import React, { Component } from 'react'

import Loading from '../../components/shared/Loading'

import { ForgotPasswordForm } from './ForgotPasswordForm'
import { Message } from './Message'

import { forgotPassword } from '../../../lib/authentication'

import { createIdentityMap } from '../utils'

import routes from '../../constants/routes'

import './auth.scss'

const Stages = createIdentityMap(
  'ENTERING_USERNAME',
  'SUBMITTING_FORGOT_PASSWORD',
  'VALID_FORGOT_PASSWORD',
  'INVALID_FORGOT_PASSWORD'
)

export default class ForgotPassword extends Component {
  constructor(props) {
    super(props)

    this.state = {
      username: '',
      error: { errorSummary: '', errorItems: [] },
      stage: Stages.ENTERING_USERNAME,
    }
  }

  setError(errorSummary, ...errorItems) {
    this.setState({ error: { errorSummary, errorItems } })
  }

  setStage(stage) {
    this.setState({ stage })
  }

  isOnStage(...stages) {
    return stages.includes(this.state.stage)
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value
    })
  }

  //TODO: If password reset was successful, we should already be logged in
  // So display a link to /submissions in the success message?
  handleFormSubmit = async (event) => {
    event.preventDefault()

    this.setError()
    this.setStage(Stages.SUBMITTING_FORGOT_PASSWORD)

    const { success, error } = await forgotPassword(this.state.username)

    if (!success && error) {
      const { errorSummary = '', errorItems = [] } = error
      this.setError(errorSummary, ...errorItems)
      this.setStage(Stages.INVALID_FORGOT_PASSWORD)
      return
    }

    if (success && !error) {
      this.setStage(Stages.VALID_FORGOT_PASSWORD)
      return
    }

    this.setError('Unknown Error occurred', 'Please try again')
    this.setStage(Stages.ENTERING_USERNAME)
  }

  validateForm = () => {
    const { username } = this.state
    const isProbablyEmail = username.length && /^.+@.+\..+$/.test(username)
    return isProbablyEmail
  }

  renderForm() {
    const { username } = this.state
    return (
      <ForgotPasswordForm
        onSubmit={this.handleFormSubmit}
        onChange={this.handleChange}
        validateForm={this.validateForm}
        username={username}
      >
        { this.isOnStage(Stages.INVALID_FORGOT_PASSWORD) && this.renderErrors() }
      </ForgotPasswordForm>
    )
  }

  renderErrors() {
    const { error: { errorSummary = 'Unknown Error Ocurred', errorItems = [] } = {} } = this.state
    return (
      <Message title={errorSummary} type="danger">
        { errorItems.map(errorItem => (<p key={btoa(errorItem)}>{errorItem}</p>)) }
      </Message>
    )
  }

  renderValidMessage() {
    return (
      <Message title="Password Recovery Sent!" type="success">
        <p>Check your email for a link that will continue the password recovery process</p>
        <p>It is possible that the email may be caught by your spam filters - check your spam folder just in case</p>
        <p>If you do not receive the email after 10 minutes, you can
          <button type="button" className="btn btn-link pn" onClick={() => this.setState({ username: '', stage: Stages.ENTERING_USERNAME })}> &nbsp;retry the password reset process</button>
        </p>
      </Message>
    )
  }

  render() {
    return (
      <div className="AuthContainer container vertical">
        { this.isOnStage(Stages.SUBMITTING_FORGOT_PASSWORD) && <Loading classes="loading" /> }
        { this.isOnStage(Stages.ENTERING_USERNAME, Stages.INVALID_FORGOT_PASSWORD) && this.renderForm() }
        { this.isOnStage(Stages.VALID_FORGOT_PASSWORD) && this.renderValidMessage() }
      </div>
    )
  }
}

